// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import Card from 'common/components/Card';
import SalesPromotion from 'common/modules/sales/domain/SalesPromotion';
import DateRangeDisplay from 'common/components/DateRangeDisplay';
import { Table, TableHeader, TableRow, TableBody, Cell, HeaderText } from 'common/components/Tables';
import { Percent, Currency } from 'common/components/Number';

const STable = styled(Table)`
  table-layout: fixed;
`;

const STableBody = styled(TableBody)`
  td {
    height: ${({ theme }) => theme.metrics.table.rowHeight}px;
  }
`;

const TextCell = styled(Cell)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

type Props = {
  salesPromotions: SalesPromotion[];
  t: any;
}

function SalesPromotionTable({ salesPromotions, t }: Props) {
  return (
    <Card>
      <STable>
        <TableHeader>
          <TableRow>
            <HeaderText>{t('campaign')}</HeaderText>
            <HeaderText>{t('customers')}</HeaderText>
            <HeaderText>{t('timeSlot')}</HeaderText>
            <HeaderText>{t('nbOfSpots')}</HeaderText>
            <HeaderText>{t('cost')}</HeaderText>
            <HeaderText>{t('discount')}</HeaderText>
          </TableRow>
        </TableHeader>
        <STableBody>
          {salesPromotions.map(salesPromotion => (
            <TableRow key={salesPromotion.getReference()}>
              <TextCell>{salesPromotion.getTitle()}</TextCell>
              <TextCell>{salesPromotion.getAdvertiser().name}</TextCell>
              <Cell><DateRangeDisplay value={salesPromotion.getDateRange()} /></Cell>
              <Cell>{salesPromotion.getNumberOfSpots()}</Cell>
              <Cell><Currency value={salesPromotion.getCost()} /></Cell>
              <Cell><Percent value={salesPromotion.getDiscount()} /></Cell>
            </TableRow>
          ))}
        </STableBody>
      </STable>
    </Card>
  );
}

export default translate('promotion')(SalesPromotionTable);



// WEBPACK FOOTER //
// ./src/statsradio/modules/promotions/components/SalesPromotionTable.js